import { cn } from '@/lib/utils';

interface StorefrontFlowlineProps {
  className?: string;
  inverse?: boolean;
}

/**
 * Courbe décorative commune aux surfaces publiques Velko.
 * Elle n'exprime aucun état métier et reste volontairement ignorée par l'a11y.
 */
export function StorefrontFlowline({ className, inverse = false }: StorefrontFlowlineProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 1200 48"
      preserveAspectRatio="none"
      className={cn('pointer-events-none block h-8 w-full', className)}
    >
      <path
        d="M0 29C146 48 254 7 421 18C598 29 679 53 839 30C1001 7 1089 7 1200 20"
        fill="none"
        stroke={inverse ? 'rgba(255,255,255,.45)' : 'var(--store-accent)'}
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M0 38C154 54 274 20 431 27C590 34 688 58 846 38C1007 17 1096 15 1200 28"
        fill="none"
        stroke={inverse ? 'rgba(255,255,255,.14)' : 'var(--store-accent)'}
        strokeOpacity={inverse ? undefined : 0.18}
        strokeWidth="8"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
